const suggestionDb = require('./suggestion-db')
const dtHandler = require('../../../../../components/dt/dt-handler')

export function init(detail) {
    // Mes Actual
    bestItemsTable(detail)
    bestProviderItemTable(detail)
    bestCustomerItemTable(detail)

    // Históricos
    bestItemsTableHistory(detail)
    bestProviderItemTableHistory(detail)
    bestCustomerItemTableHistory(detail)

    const cont = document.querySelector('#suggestion-page .title');
    const date = new Date();
    const monthName = date.toLocaleString('en-US', { month: 'long' });
    cont.innerHTML = `Items performance on ${monthName}`

    const contHistory = document.querySelector('#suggestion-page-right .title');
    if (contHistory) contHistory.innerHTML = "Historical Performance";

    return
}

// --- TABLAS MES ACTUAL ---

function bestItemsTable(detail) {
    suggestionDb.load(
        { 'file': 'item_best_ten', 'filter': 'current' },
        (result) => {
            const columns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: true},
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: true},
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: true },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: true},
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: true },
            ];

            const bestTable = dtHandler.dtSimpleFc(result.data, columns);
            const lowerTable = dtHandler.dtSimpleFc(result.low_profit, columns);

            document.querySelector('#suggestion-item-last-movements').innerHTML = bestTable;
            document.querySelector('#suggestion-item-lower-movements').innerHTML = lowerTable;
        }
    )
}

function bestProviderItemTable(detail) {
    suggestionDb.load(
        { 'file': 'provider_item_best_ten', 'filter': 'current' },
        (result) => {
            const columns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'provider_name', label: 'Provider', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },
            ];

            const bestTable = dtHandler.dtSimpleFc(result.data, columns);
            const lowerTable = dtHandler.dtSimpleFc(result.low_profit, columns);

            document.querySelector('#suggestion-provider-item-last-movements').innerHTML = bestTable;
            document.querySelector('#suggestion-provider-item-lower-movements').innerHTML = lowerTable;
        }
    )
}

function bestCustomerItemTable(detail) {
    suggestionDb.load(
        { 'file': 'customer_item_best_ten', 'filter': 'current' },
        (result) => {
            const columns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'customer_name', label: 'Seller', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },
            ];

            const bestTable = dtHandler.dtSimpleFc(result.data, columns);
            const lowerTable = dtHandler.dtSimpleFc(result.low_profit, columns);

            document.querySelector('#suggestion-customer-item-last-movements').innerHTML = bestTable;
            document.querySelector('#suggestion-customer-item-lower-movements').innerHTML = lowerTable;
        }
    )
}

// --- TABLAS HISTÓRICAS (Misma estructura, IDs con -history) ---

function bestItemsTableHistory(detail) {
    suggestionDb.load(
        { 'file': 'item_best_ten', 'filter': 'all' },
        (result) => {
            const columns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },
            ];
            const bestTable = dtHandler.dtSimpleFc(result.data, columns);
            const lowerTable = dtHandler.dtSimpleFc(result.low_profit, columns);

            document.querySelector('#suggestion-item-last-movements-history').innerHTML = bestTable;
            document.querySelector('#suggestion-item-lower-movements-history').innerHTML = lowerTable;
        }
    )
}

function bestProviderItemTableHistory(detail) {
    suggestionDb.load(
        { 'file': 'provider_item_best_ten', 'filter': 'all' },
        (result) => {
            const columns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'provider_name', label: 'Provider', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },
            ];
            const bestTable = dtHandler.dtSimpleFc(result.data, columns);
            const lowerTable = dtHandler.dtSimpleFc(result.low_profit, columns);

            document.querySelector('#suggestion-provider-item-last-movements-history').innerHTML = bestTable;
            document.querySelector('#suggestion-provider-item-lower-movements-history').innerHTML = lowerTable;
        }
    )
}

function bestCustomerItemTableHistory(detail) {
    suggestionDb.load(
        { 'file': 'customer_item_best_ten', 'filter': 'all' },
        (result) => {
            const columns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'customer_name', label: 'Seller', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },
            ];
            const bestTable = dtHandler.dtSimpleFc(result.data, columns);
            const lowerTable = dtHandler.dtSimpleFc(result.low_profit, columns);

            document.querySelector('#suggestion-customer-item-last-movements-history').innerHTML = bestTable;
            document.querySelector('#suggestion-customer-item-lower-movements-history').innerHTML = lowerTable;
        }
    )
}